"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldDiff = exports.FieldUtils = exports.WebhookHTTPMethod = exports.PageResult = exports.ApiError = void 0;
var cerealParse_1 = require("../cerealParse");
/**
 * Class representing an ApiError and providing a static parse method.
 */
var ApiError = /** @class */ (function () {
    function ApiError(realCause, message, errors) {
        this.realCause = realCause;
        this.message = message;
        this.errors = errors;
    }
    /**
     * Parse object potentially representing a ApiError.
     * @param o
     * @return Parse result
     */
    ApiError.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ApiError(cerealParse_1.ParseUtils.getStringOrNull(o, 'realCause'), cerealParse_1.ParseUtils.getString(o, 'message'), cerealParse_1.ParseUtils.getArrayOrNull(o, 'errors')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Api Error: ".concat(e.message));
        }
    };
    return ApiError;
}());
exports.ApiError = ApiError;
/**
 * Class representing a page result and providing a static parse method.
 * @typeparam T
 */
var PageResult = /** @class */ (function () {
    function PageResult(count, items) {
        this.count = count;
        this.items = items;
    }
    /**
     * Parse object potentially representing a PageResult.
     * @typeparam T
     * @param o
     * @return Parse result
     */
    PageResult.parse = function (o, itemsKey, itemParser) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new PageResult(cerealParse_1.ParseUtils.getNumber(o, 'count'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, itemsKey, itemParser, 'throw')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid PageResult Model: ".concat(e.message));
        }
    };
    return PageResult;
}());
exports.PageResult = PageResult;
var WebhookHTTPMethod;
(function (WebhookHTTPMethod) {
    WebhookHTTPMethod[WebhookHTTPMethod["get"] = 0] = "get";
    WebhookHTTPMethod[WebhookHTTPMethod["post"] = 1] = "post";
})(WebhookHTTPMethod || (exports.WebhookHTTPMethod = WebhookHTTPMethod = {}));
/**
 * Class representing field utils and providing static util methods.
 * @TODO Why isn't FieldDiff and FieldUtils combined, or all stand alone functions?
 */
var FieldUtils = /** @class */ (function () {
    function FieldUtils() {
    }
    /**
     * ??
     * @TODO Actually figure out what this method does.
     * @typeparam T
     * @param field
     * @param clearValue
     * @param transform
     * @return ??
     */
    FieldUtils.getClearableParam = function (field, clearValue, transform) {
        var finalTransform = transform != null ? transform : (function (v) { return v; });
        switch (field.key) {
            case 'set':
                return finalTransform(field.value);
            case 'clear':
                return clearValue;
            case 'ignore':
                return null;
        }
    };
    /**
     * ??
     * @TODO Actually figure out what this method does.
     * @typeparam T
     * @param field
     * @param transform
     * @return ??
     */
    FieldUtils.getEditableParam = function (field, transform) {
        var finalTransform = transform != null ? transform : (function (v) { return v; });
        switch (field.key) {
            case 'set':
                return finalTransform(field.value);
            case 'ignore':
                return null;
        }
    };
    return FieldUtils;
}());
exports.FieldUtils = FieldUtils;
/**
 * Class representing field diff and providing util methods.
 * @TODO Why isn't FieldDiff and FieldUtils combined, or all stand alone functions?
 */
var FieldDiff = /** @class */ (function () {
    function FieldDiff() {
        this.dirty = false;
    }
    /**
     * ??
     * @TODO Actually figure out what this method does.
     * @typeparam T
     * @param oldValue
     * @param newValue
     * @param compare
     * @return ??
     */
    FieldDiff.prototype.compareClearable = function (oldValue, newValue, compare) {
        var finalCompare = compare != null ? compare : function (e1, e2) { return e1 == e2; };
        if ((oldValue == null && newValue == null)
            || (oldValue != null && newValue != null && finalCompare(oldValue, newValue))) {
            return { key: 'ignore' };
        }
        else if (newValue == null) {
            this.dirty = true;
            return { key: 'clear' };
        }
        else {
            this.dirty = true;
            return { key: 'set', value: newValue };
        }
    };
    /**
     * ??
     * @TODO Actually figure out what this method does.
     * @typeparam T
     * @param oldValue
     * @param newValue
     * @param compare
     * @return ??
     */
    FieldDiff.prototype.compareEditable = function (oldValue, newValue, compare) {
        var finalCompare = compare != null ? compare : function (e1, e2) { return e1 == e2; };
        if (finalCompare(oldValue, newValue)) {
            return { key: 'ignore' };
        }
        else {
            this.dirty = true;
            return { key: 'set', value: newValue };
        }
    };
    return FieldDiff;
}());
exports.FieldDiff = FieldDiff;
//# sourceMappingURL=bryxTypes.js.map